import { render, staticRenderFns } from "./BillList.vue?vue&type=template&id=4f6c1acf&scoped=true&"
import script from "./BillList.vue?vue&type=script&lang=ts&"
export * from "./BillList.vue?vue&type=script&lang=ts&"
import style0 from "./BillList.vue?vue&type=style&index=0&id=4f6c1acf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6c1acf",
  null
  
)

export default component.exports